import React, { useEffect, useState } from "react"
import { Provinces } from "../../common/data/Provinces"
import { Cities } from "../../common/data/Cities"
import { Section } from "../../common/data/Section"
import { Col, Form, Row, Select, Space, Tag, Typography } from "antd"
import { EnvironmentOutlined, BankOutlined, AppstoreOutlined } from "@ant-design/icons"

const { Text } = Typography

const Locations = ({
  setDataAddress,
  matches_sm,
  idSection,
  isAccessCity = true,
  isAccessSection = true,
  inUseFilter = false,
}) => {
  const [cityList, setCityList] = useState([])
  const [sectionList, setSectionList] = useState([])
  const [selectProvince, setSelectProvince] = useState({ id: 13, label: "" })
  const [selectCity, setSelectCity] = useState({ id: 0, label: "" })
  const [selectSection, setSelectSection] = useState({ id: 0, label: "" })
  const provinceList = Provinces.map(val => ({
    label: val.ProvinceName,
    value: val.Id,
  }))
  const getLatLongCity = idCity => {
    return idCity
      ? Cities.filter(c => c.Id === idCity)
      : Cities.filter(c => c.Id === 31)
  }

  const handleChangeProvince = value => {
    const selected = Provinces.find(p => p.Id === value)
    const newListCity = Cities.filter(ee => ee.Id_Province === value)

    setCityList(
      newListCity.map(val => ({ label: val.CityName, value: val.Id }))
    )

    setSelectProvince({ id: value, label: selected?.ProvinceName || "" })
  }

  const handleChangeCity = value => {
    const newListSection = Section.filter(ee => ee?.Id_City === value)
    const CitySelected = Cities.find(ee => ee.Id === value)
    setSectionList(
      newListSection.map(val => ({ label: val.SectionName, value: val.Id }))
    )
    setSelectCity({ id: value, label: CitySelected.CityName })
    const findCenterId = newListSection.find(ls => ls.SectionName === "مرکزی")
    if (inUseFilter) setSelectSection({ id: 0, label: "همه" })
    if (!inUseFilter) setSelectSection({ id: findCenterId.Id, label: "مرکزی" })
  }

  const handleChangeSection = value => {
    const SectionSelected = Section.find(ee => ee.Id === value)
    setSelectSection({ id: value || 0, label: SectionSelected?.SectionName || "همه" })
  }

  useEffect(() => {
    const newListCity = Cities.filter(ee => ee.Id_Province === 13)
    setCityList(
      newListCity.map(val => ({ label: val.CityName, value: val.Id }))
    )
    if (idSection) {
      const SectionSelected = Section.find(ee => ee.Id === idSection)
      if (SectionSelected) {
        const CitySelected = Cities.find(
          ee => ee.Id === SectionSelected?.Id_City
        )
        setSelectCity({ id: CitySelected.Id, label: CitySelected.CityName })
        setSelectProvince({ id: 13, label: "کردستان" })
        return
      }
    }
    setSelectCity({ id: 31, label: "سنندج" })
    setSelectProvince({ id: 13, label: "کردستان" })
  }, [Cities, idSection])

  useEffect(() => {
    if (idSection) {
      const SectionSelected = Section.find(ee => ee.Id === idSection)
      const newListSection = Section.filter(
        ee => ee.Id_City === SectionSelected?.Id_City
      )
      setSectionList(
        newListSection.map(val => ({ label: val.SectionName, value: val.Id }))
      )
      setSelectSection({
        id: SectionSelected?.Id,
        label: SectionSelected.SectionName,
      })
      return
    }
    const newListSection = Section.filter(ee => ee?.Id_City === 31)
    setSectionList(
      newListSection.map(val => ({ label: val.SectionName, value: val.Id }))
    )
    if (!inUseFilter) setSelectSection({ id: 10184, label: "مرکزی" })
    if (inUseFilter) setSelectSection({ id: 0, label: "همه" })
  }, [Section, idSection])

  useEffect(() => {
    const getlatlong = getLatLongCity(selectCity.id)[0]
    setDataAddress({
      sectionId: selectSection.id,
      cityId: selectCity.id,
      provinceId: selectProvince.id,
      fullAddress: {
        pro: selectProvince.label,
        cit: selectCity.label,
        sec: selectSection.label,
        lat: getlatlong.Longitude,
        lng: getlatlong.Latitude,
      },
    })
  }, [selectProvince, selectCity, selectSection])

  const selectStyle = {
    width: "100%",
    height: matches_sm ? 44 : 40,
  }

  const sectionOptions = [
    ...(inUseFilter ? [{ label: "همه", value: 0 }] : []),
    ...sectionList,
  ]

  return (
    <Row gutter={[matches_sm ? 8 : 12, matches_sm ? 8 : 12]}>
      <Col xs={12} sm={12} md={12}>
        <Form.Item style={{ margin: 0 }}>
          <Space size={4} direction="vertical" style={{ width: "100%" }}>
            <Space size={4}>
              <BankOutlined style={{ color: "#1677ff", fontSize: matches_sm ? 13 : 14 }} />
              <Text type="secondary" style={{ fontSize: matches_sm ? 12 : 13 }}>شهرستان</Text>
            </Space>
            <Select
              showSearch
              optionFilterProp="label"
              size={matches_sm ? "large" : "middle"}
              disabled={!isAccessCity}
              placeholder="انتخاب شهرستان"
              value={selectCity.id || undefined}
              onChange={handleChangeCity}
              options={cityList}
              style={selectStyle}
              popupMatchSelectWidth={false}
              suffixIcon={<BankOutlined style={{ color: "#1677ff" }} />}
            />
          </Space>
        </Form.Item>
      </Col>
      <Col xs={12} sm={12} md={12}>
        <Form.Item style={{ margin: 0 }}>
          <Space size={4} direction="vertical" style={{ width: "100%" }}>
            <Space size={4}>
              <AppstoreOutlined style={{ color: "#52c41a", fontSize: matches_sm ? 13 : 14 }} />
              <Text type="secondary" style={{ fontSize: matches_sm ? 12 : 13 }}>بخش</Text>
            </Space>
            <Select
              showSearch
              optionFilterProp="label"
              size={matches_sm ? "large" : "middle"}
              disabled={!isAccessSection}
              placeholder="انتخاب بخش"
              value={selectSection.id === 0 && inUseFilter ? 0 : selectSection.id || undefined}
              onChange={handleChangeSection}
              options={sectionOptions}
              style={selectStyle}
              popupMatchSelectWidth={false}
              suffixIcon={<AppstoreOutlined style={{ color: "#52c41a" }} />}
            />
          </Space>
        </Form.Item>
      </Col>
      {selectCity.label && selectSection.label && (
        <Col xs={24}>
          <Space size={6} wrap style={{ paddingTop: 2 }}>
            <EnvironmentOutlined style={{ color: "#fa8c16", fontSize: 13 }} />
            <Text type="secondary" style={{ fontSize: matches_sm ? 11 : 12 }}>موقعیت انتخابی:</Text>
            <Tag color="blue" style={{ borderRadius: 6, fontSize: matches_sm ? 11 : 12 }}>
              {selectProvince.label}
            </Tag>
            <Tag color="orange" style={{ borderRadius: 6, fontSize: matches_sm ? 11 : 12 }}>
              {selectCity.label}
            </Tag>
            <Tag color="green" style={{ borderRadius: 6, fontSize: matches_sm ? 11 : 12 }}>
              {selectSection.label}
            </Tag>
          </Space>
        </Col>
      )}
    </Row>
  )
}

export default Locations
